import firebase from 'firebase/app'
import 'firebase/analytics'

const analytics = firebase.analytics()

const getPath = ({ node }) => {
  const { $options: { _componentTag } } = node
  if (!_componentTag) {
    return ``
  }

  const componentTag = _componentTag.split(`-`)
    .map(word => `${word[0].toUpperCase()}${word.slice(1)}`)
    .slice(1)
    .join(``)

  if (_componentTag.startsWith(`v-`) || componentTag === `Layout`) {
    return getPath({ node: node.$parent })
  }

  return `${getPath({ node: node.$parent })}/${componentTag}`
}

/**
 * - params
 * - async
 * - dispatch event on call
 * - native API call
 */
export default function (object, params) {
  const functionName = typeof object === 'function'
    ? `click`
    : Object.keys(object)[0]


  const callback = async params => {
    const name = `${this ? getPath({ node: this._self }) : ``}->${functionName}`
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView?.postMessage(JSON.stringify({
        name: `analyticsLog`,
        params: {
          name,
          params
        }
      }))
    } else {
      analytics.logEvent(
        `click`, {
          name
        }
      )
    }
    await (typeof object === 'function'
      ? object
      : object[functionName]
    )(params)
  }

  return this ? callback(params) : async () => {
    await callback(params)
  }
}
